import { IdsMainButton } from "@ids/react"

import { formatters } from "@garantidos/utils"

import { useSimulationOffer } from "./hooks"

import "./style.scss"

import { SimulationOfferDetails } from "../OfferDetails"
import { simulationOfferAmortizationSystemTexts } from "./data"

export function SimulationOffer({ offer }) {
  const {
    isDetailsModalOpen,
    onDetailsModalOpen,
    onDetailsModalClose,
    onSubmitOffer
  } = useSimulationOffer({ offer })

  const amortizationSystemTexts =
    simulationOfferAmortizationSystemTexts[offer.amortization_system]
    const ariaLabelDetalhes = `Detalhes da simulação ${amortizationSystemTexts.tag}`;
    const ariaLabelSeguir = `seguir com essas condições ${amortizationSystemTexts.tag}`;

  return (
    <li>
      <div data-testid={offer.amortization_system} className="simulation-offer">
        <h3 className="simulation-offer__tag">{amortizationSystemTexts.tag}</h3>

        <div className="simulation-offer__installments">
          <div className="simulation-offer__installment">
            <p className="simulation-offer__installment-title">
              Primeira parcela
            </p>
            <p className="simulation-offer__installment-value">
              {formatters.toCurrency(offer.initial_installment)}
            </p>
          </div>
          <div className="simulation-offer__installment">
            <p className="simulation-offer__installment-title">
              Última parcela
            </p>
            <p className="simulation-offer__installment-value">
              {formatters.toCurrency(offer.last_installment)}
            </p>
          </div>
        </div>

        <div className="simulation-offer__rates">
          <div className="simulation-offer__rate">
            <p className="simulation-offer__rate-title">Taxas de juros</p>
            <p className="simulation-offer__rate-value">
              {`${formatters.floatToDisplayableNumber(
                offer.monthly_effective_rate
              )}% a.m. ou ${formatters.floatToDisplayableNumber(
                offer.yearly_effective_rate
              )}% a.a.`}
            </p>
          </div>
          <div className="simulation-offer__rate">
            <p className="simulation-offer__rate-title">Custo efetivo total</p>
            <p className="simulation-offer__rate-value">
              {`${formatters.floatToDisplayableNumber(
                offer.monthly_effective_interest_rate
              )}% a.m. ou ${formatters.floatToDisplayableNumber(
                offer.yearly_effective_interest_rate
              )}% a.a.`}
            </p>
          </div>
        </div>

        <div className="simulation-offer__actions">
          <IdsMainButton
            aria-label={ariaLabelDetalhes}
            variant="secondary"
            full
            onClick={onDetailsModalOpen}
          >
            Detalhes
          </IdsMainButton>
          <IdsMainButton
            id="choose-conditions-button"
            data-testid={`choose-conditions-button_${offer.amortization_system}`}
            aria-label={ariaLabelSeguir}
            full
            onClick={onSubmitOffer}
          >
            Seguir
          </IdsMainButton>
        </div>

        <SimulationOfferDetails
          show={isDetailsModalOpen}
          onCloseClick={onDetailsModalClose}
          offer={offer}
          onSubmitOffer={onSubmitOffer}
        />
      </div>
    </li>
  )
}
